import { db } from "@/repositories/database";
import type { LegendDwgCache } from "@/types/legend.types";

class LegendDwgCacheRepository {
  async get(legendId: number, dwgFileId: number): Promise<ArrayBuffer | null> {
    const entry = await db.legendDwgFiles.get(legendId);
    if (!entry || entry.dwgFileId !== dwgFileId) return null;
    return entry.buffer;
  }

  put(legendId: number, dwgFileId: number, buffer: ArrayBuffer): Promise<number> {
    const entry: LegendDwgCache = {
      id: legendId,
      dwgFileId,
      buffer,
      cachedAt: Date.now(),
    };
    return db.legendDwgFiles.put(entry);
  }

  remove(legendId: number): Promise<void> {
    return db.legendDwgFiles.delete(legendId);
  }

  pruneToLegendIds(validLegendIds: number[]): Promise<number> {
    return db.legendDwgFiles.where("id").noneOf(validLegendIds).delete();
  }
}

export const legendDwgCacheRepository = new LegendDwgCacheRepository();
